import _ from 'lodash';
import Vue from 'vue';
import { useGlobalVars } from '@/composables';
import { resolveRuntimeUiConfig } from '@/utils/runtime-ui-urls';
import { getUIConfig } from '@/utils/ui-config';

/**
 * OR Config is available only in App Launcher and is provided in root component.
 * In Action Desk mode we use "$helpers" instead.
 */
export const useOneReachConfig = () => {
  const { getVueGlobals } = useGlobalVars();

  /** Variables are available only in App Launcher during bundle deployment */
  const initializeORConfig = () => {
    const config = getUIConfig();
    getVueGlobals().$ORConfig = config;
    /* Compatibility feature with versions >=0.65.0 */
    Vue.prototype.$ORConfig = config;
  };

  /** Some OR config variables can be used as is while some require additional processing */
  const getORConfig = () => {
    const ORConfig = getVueGlobals().$ORConfig || {};
    const cachedRuntimeConfig = (ORConfig as any).__runtimeUiConfig;

    if (cachedRuntimeConfig) {
      return cachedRuntimeConfig;
    }

    const FEATURE_INDICATOR = 'FEATURE.';
    const ACTION_DESK_URL = (ORConfig.serviceList as any)?.actiondesk ?? '';

    const trimFeatureIndicator = (url = '') => {
      return url.replace(FEATURE_INDICATOR, '');
    };

    const getHTTPGatewayURL = (key: string, accountId: string) => {
      const gatewayURL = trimFeatureIndicator(ORConfig.GATEWAY_URL);
      return `${gatewayURL}/${accountId}/${key}`;
    };

    const getWebRTCAddress = () => {
      return `wss://${ORConfig.WEBRTC_DOMAIN}:${ORConfig.WEBRTC_WSS_PORT}`;
    };

    const runtimeUiConfig = resolveRuntimeUiConfig({
      AUTH_UI_ALIASES: ORConfig.AUTH_UI_ALIASES || [],
      AUTH_UI_URL: trimFeatureIndicator(ORConfig.AUTH_UI_URL),
      COOKIE_DOMAIN: ORConfig.COOKIE_DOMAIN,
      HITL_UI_ALIASES: ORConfig.HITL_UI_ALIASES || [],
      HITL_UI_URL: trimFeatureIndicator(ORConfig.HITL_UI_URL),
      SDK_API_ALIASES: ORConfig.SDK_API_ALIASES || [],
      SDK_API_URL: trimFeatureIndicator(ORConfig.SDK_API_URL),
    });
    const methods = { getHTTPGatewayURL, getWebRTCAddress };
    const constants = {
      ACTION_DESK_UI_URL: trimFeatureIndicator(ACTION_DESK_URL),
      ...runtimeUiConfig,
    };

    const resolvedConfig = _.assign(ORConfig, constants, methods);
    (ORConfig as any).__runtimeUiConfig = resolvedConfig;
    return resolvedConfig;
  };

  return { initializeORConfig, getORConfig };
};
